import React from 'react'

import DrawerMenuItem from './drawerMenuItem'

const DrawerMenu: React.FC = () => {
	return (
		<div className="w-full h-full bg-gray-900">
			<div className="p-8">
				<img src="/img/logo.png" className="text-white stroke-current fill-current" alt="" />
			</div>
			<DrawerMenuItem label="Transactions" link="/transactions" className="mt-2" />
			<DrawerMenuItem label="Users" link="/users" className="mt-2" />
		</div>
	)
}

export default DrawerMenu
